import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TEmailABTestVariation } from '@feathr/blackbox';
import { CardV2 as Card, EmptyState } from '@feathr/components';
import { getEmailABTestVersionLabel } from '@feathr/extender/utils/emailABTest';

import type { IABTestLine } from './ABTestLineChart';
import ABTestLineChart from './ABTestLineChart';
import type { IABTestActivityPoint } from './ABTestReport.types';
import { AB_TEST_ACTIVITY_COLORS } from './ABTestReport.utils';

import * as styles from './ABTestVersionChart.css';

interface IProps {
  activity?: IABTestActivityPoint[];
  variation: TEmailABTestVariation;
}

function ABTestVersionChart({ activity, variation }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  const lines: Array<IABTestLine<IABTestActivityPoint>> = [
    { ...AB_TEST_ACTIVITY_COLORS.sends, dataKey: 'sends', name: t('Sends') },
    { ...AB_TEST_ACTIVITY_COLORS.deliveries, dataKey: 'deliveries', name: t('Deliveries') },
    { ...AB_TEST_ACTIVITY_COLORS.opens, dataKey: 'opens', name: t('Opens') },
    { ...AB_TEST_ACTIVITY_COLORS.clicks, dataKey: 'clicks', name: t('Clicks') },
  ];

  return (
    <Card width={'full'}>
      <Card.Header title={getEmailABTestVersionLabel(variation, t)} />
      {activity ? (
        <Card.Content contentClassName={styles.content}>
          <ABTestLineChart data={activity} lines={lines} />
        </Card.Content>
      ) : (
        <Card.Content>
          <EmptyState label={t('No data available')} theme={'white'} width={'full'} />
        </Card.Content>
      )}
    </Card>
  );
}

export default ABTestVersionChart;
